import { Button, type ButtonProps } from '~/components/ui/button'
import { Spinner } from '~/components/ui/spinner'
import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip'
import { useFormContext } from '~/hooks/form-hooks'
import { usePermissionGuard, type PermissionRequirement } from '~/utils/rbac'

export type SubmitButtonProps = ButtonProps & {
  /** Droit(s) requis pour enregistrer. Absent = pas de garde RBAC. */
  permission?: PermissionRequirement
}

export const SubmitButton = ({ disabled, children, permission, ...props }: SubmitButtonProps) => {
  const form = useFormContext()
  const guard = usePermissionGuard(permission)

  const button = (
    <form.Subscribe selector={(state) => [state.isSubmitting]}>
      {([isSubmitting]) => (
        <Button
          disabled={disabled || isSubmitting || !guard.authorized}
          {...props}
          nativeButton
          type="submit"
        >
          {children}
          {isSubmitting && <Spinner className="ml-2" />}
        </Button>
      )}
    </form.Subscribe>
  )

  if (guard.authorized) return button

  // Un bouton désactivé n'émet pas d'évènement pointeur : le déclencheur du tooltip est un `<span>`.
  return (
    <Tooltip>
      <TooltipTrigger render={<span tabIndex={0} />}>{button}</TooltipTrigger>
      <TooltipContent>{guard.tooltip}</TooltipContent>
    </Tooltip>
  )
}
